import React from 'react'
import { NavLink } from 'react-router-dom';

function LinksWidget({ links }) {
    return (
        <>
            <div className="links-widget shadow-sm">
                {links.map((link, i) =>
                    <NavLink key={i} to={link.to}
                    className={({ isActive }) => isActive ? "matches-link-active" : ""}
                    >{link.name}</NavLink>
                )}

            </div>
        </>
    )
}

export default LinksWidget